export type Brand = {
  name: string;
  slug: string;
  logo: string;
};

export const BRANDS: Brand[] = [
  { name: "Daikin", slug: "daikin", logo: "/images/brands/daikin.svg" },
  { name: "Mitsubishi Electric", slug: "mitsubishi", logo: "/images/brands/mitsubishi.svg" },
  { name: "Panasonic", slug: "panasonic", logo: "/images/brands/panasonic.svg" },
  { name: "Toshiba", slug: "toshiba", logo: "/images/brands/toshiba.svg" },
  { name: "Mitsubishi Heavy Industries", slug: "mitsubishi-heavy", logo: "/images/brands/mitsubishi-heavy.svg" },
  { name: "Carrier", slug: "carrier", logo: "/images/brands/carrier.svg" },
];
